// extracted by mini-css-extract-plugin
export default {"swippyInput":"SwippyInput_swippyInput__pAxI+","hideNumberArrows":"SwippyInput_hideNumberArrows__OBsED"};